import { useGlobMap } from 'liyu-pc-base/init-plugin';
const res_components: { [key: string]: any } = {};
const init = () => {
  if (Object.keys(res_components).length > 0) {
    return;
  }
  const allComponents: any = import.meta.glob(
    'liyu-pc-base/components/FormRender/RemoteModal/configs/*/*.ts',
    {
      eager: true,
    },
  );
  const customComponents = useGlobMap('remoteModal');
  Object.assign(allComponents, customComponents);
  Object.keys(allComponents).forEach(full_file_name => {
    const file_name_list = full_file_name.split('/');
    const file_name = file_name_list[file_name_list.length - 1].replace('.ts', '');
    res_components[file_name] = allComponents[full_file_name].default;
  });
};

export default (modalType: string) => {
  init();
  if (res_components[modalType] == undefined) {
    console.error('没有组件：' + modalType);
  }
  return {
    ...res_components[modalType](),
  };
};
